import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'

export interface IEditHallPayload extends ISagaCb {
    hallId: string
    data: {
        name: string
        address: string
        notes: string
    }
}

export interface IEditHallState {
    status: string
    data: any
    errors: any
}

const initialState: IEditHallState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const editHall = createSlice({
    name: 'hall/edit',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IEditHallPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const editHallActions = editHall.actions
export default editHall.reducer
